import { FC } from 'react';

import CorporateRegisterForm from '@/components/layout/corporateRegisterPage/CorporateRegisterForm.tsx';

const CorporateRegister: FC = () => {
  return (
    <div className="self-center w-[calc(100vw-2rem)] max-w-[400px] md:max-w-[450px] fluid-desktop:max-w-[500px] xl:max-w-[650px] fluid-desktop:w-[40vw] xl:w-[30vw] min-w-0 nest-hub-form-width">
      <CorporateRegisterForm />
    </div>
  );
};

export default CorporateRegister;
